<select class="picker" name="options" id="options">
  <option *ngFor="let option of options; let i = index" value="option">
    {{ option }}
  </option>
</select>
